import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'companyName',
    title: 'Customer name',
    show: true,
    width: 417,
    valuesExport: [
      'companyName',
      'customerId',
      'companySize',
      'country',
      'website'
    ]
  },
  {
    isSortable: true,
    field: 'healthStatus',
    title: 'Health Score',
    show: true,
    width: 164,
    valuesExport: ['healthStatus, healthPoint']
  },
  {
    isSortable: true,
    field: 'plan',
    title: 'Pricing Plan',
    show: true,
    width: 132,
    valuesExport: ['plan']
  },
  {
    isSortable: true,
    field: 'billingCycle',
    title: 'Billing Cycle',
    show: true,
    width: 162,
    valuesExport: ['billingCycle']
  },
  {
    isSortable: false,
    field: 'arr',
    title: 'ARR',
    show: true,
    width: 132,
    valuesExport: ['arr']
  },
  {
    isSortable: true,
    field: 'firstPaymentDate',
    title: 'First Payment',
    show: true,
    width: 156,
    valuesExport: ['firstPaymentDate']
  },
  {
    isSortable: true,
    field: 'firstInvoiceAt',
    title: 'First Invoice',
    show: true,
    width: 156,
    valuesExport: ['firstInvoiceAt']
  },
  {
    isSortable: true,
    field: 'nextBillingDate',
    title: 'Next Billing',
    show: true,
    width: 136,
    valuesExport: ['nextBillingDate']
  },
  {
    isSortable: true,
    field: 'accountManager',
    title: 'Acc. Manager',
    show: true,
    width: 162,
    valuesExport: ['accountManager']
  },
  {
    isSortable: true,
    field: 'customerSuccessEngineer',
    title: 'CS Engineer',
    show: true,
    width: 162,
    valuesExport: ['customerSuccessEngineer']
  }
];

export const defaultFilters = {
  search: '',
  firstPaymentDate: { startDate: null, endDate: null },
  nextBillingDate: { startDate: null, endDate: null },
  firstInvoiceAt: { startDate: null, endDate: null },
  plan: [],
  healthStatus: [],
  billingCycle: [],
  status: [],
  companySize: [],
  country: [],
  industry: [],
  partnerType: [],
  poc: [],
  region: [],
  customerSuccessEngineer: [],
  accountManager: [],
  isTestTenant: false,
  customerIds: []
};

export const defaultNavigation = {
  fieldName: 'plan',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};
